<template>
  <div class="friend-link-form-container">
    <el-form
      ref="ruleFormRef"
      :size="formSize"
      :model="configDataForm"
      label-position="right"
      :rules="rules"
      label-width="220px"
    >
      <div class="card-frame other-card-frame">
        <div class="card-frame-top">基本配置</div>
        <div class="card-frame-container">
          <el-form-item label="背景图片：" prop="backGroundImageObj">
            <zc-upload
              v-model="configDataForm.backGroundImageObj"
              :limit-single-size="1048576"
              :image-thumbnail-width="240"
              type="singleImage"
              :enable-popup="false"
              :show-no-image="true"
              :small-text="true"
              tip="说明：上传的图片大小不得超过1M，建议尺寸1920*1080px"
              @change="handleInputChange('backGroundImageObj')"
            >
              <template #singleImageError>
                <div class="el-image__error image-error-show">图片丢失</div>
              </template>
            </zc-upload>
          </el-form-item>
          <el-form-item label="背景颜色：" prop="backGroundColor">
            <el-color-picker v-model="configDataForm.backGroundColor" />
          </el-form-item>
          <el-form-item
            label="标题图标："
            prop="iconImageObj"
            :rules="rules.backGroundImageObj"
          >
            <zc-upload
              v-model="configDataForm.iconImageObj"
              :limit-single-size="1048576"
              type="singleImage"
              :enable-popup="false"
              :show-no-image="true"
              :small-text="true"
              tip="说明：上传的图片大小不得超过1M，建议尺寸40*40px"
              @change="handleInputChange('iconImageObj')"
            >
              <template #singleImageError>
                <div class="el-image__error image-error-show">图片丢失</div>
              </template>
            </zc-upload>
          </el-form-item>

          <el-form-item label="标题：" prop="title">
            <el-input v-model="configDataForm.title" />
          </el-form-item>
          <el-form-item label="标题字体颜色：" prop="fontColor">
            <el-color-picker v-model="configDataForm.fontColor" />
          </el-form-item>
        </div>
      </div>
      <div class="card-frame other-card-frame">
        <div class="card-frame-top">友情链接区域</div>
        <div class="card-frame-container">
          <el-table
            ref="tableRef"
            :data="configDataForm.items"
            :scrollbar-always-on="true"
            class="table-data fixed-head"
            :border="true"
          >
            <el-table-column
              type="index"
              width="60"
              label="序号"
              align="center"
            />
            <el-table-column label="网站名称" align="center">
              <template #default="scope">
                <el-form-item
                  :prop="`items[${scope.$index}].siteName`"
                  :rules="rules.siteName"
                >
                  <el-input
                    v-model="configDataForm.items[scope.$index].siteName"
                  >
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="网址" align="center">
              <template #default="scope">
                <el-form-item
                  :prop="`items[${scope.$index}].siteUrl`"
                  :rules="rules.siteUrl"
                >
                  <el-input
                    v-model="configDataForm.items[scope.$index].siteUrl"
                  >
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="60">
              <template #default="scope">
                <zc-table-operate-wrap :key="Math.random()" :max-item-count="3">
                  <template v-if="configDataForm.items.length > 1">
                    <el-link type="danger" @click="handleDel(scope)">
                      移除
                    </el-link>
                  </template>
                  <template v-else>
                    <el-tooltip content="至少保留一条友情链接" placement="top">
                      <el-link type="danger" disabled> 移除 </el-link>
                    </el-tooltip>
                  </template>
                </zc-table-operate-wrap>
              </template>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24">
              <el-button
                style="width: 100%; margin-top: 10px"
                @click="handleAdd(scope)"
              >
                <el-icon><Plus /></el-icon>添加三行
              </el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div class="friend-link-btn-container">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleSave(ruleFormRef)"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script setup>
// #region 引用
import { verifyCharacterLength } from '@/utils/common/form-verify-util';
import { Plus } from '@element-plus/icons-vue';

// #endregion

// #region props/emit

/**
 * 属性
 */
const props = defineProps({
  componentData: {
    type: Object,
    default() {},
  },
});
/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'update:modelValue',
  'handle-edit-components-content',
]);

// #endregion

// #region 变量/常量

// 栏目数据列表

// 表单size
const formSize = ref('default');
const ruleFormRef = ref();

// 表单绑定对象
// 表单绑定对象
const configDataForm = ref({
  backGroundImageObj: null,
  backGroundImageName: '',
  backGroundImageFileKey: 'backgroundImage',
  backGroundColor: '#2A3347',
  title: '示例标题',
  fontColor: '#ffffff',
  iconImageObj: null,
  iconName: '示例图标1.png',
  iconFileKey: 'iconImage',
  items: [
    {
      sortNum: 1,
      siteName: '天府老年大学',
      siteUrl: 'http://www.tfu3a.com/',
    },
    {
      sortNum: 2,
      siteName: '多米岛',
      siteUrl: 'http://www.dormistore.com/',
    },
    {
      sortNum: 3,
      siteName: '康养护理学院',
      siteUrl: 'https://kyhl.tfswufe.edu.cn/',
    },
    {
      sortNum: 4,
      siteName: '乐力',
      siteUrl: 'https://www.leliwell.com/',
    },
  ],
});

// 表单绑定对象
// console.log('props-configDataForm-FriendLinkEditForm:', props);

if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);
  console.log('props:', props);

  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
  // 图标
  configDataForm.value.iconImageObj = {
    name: configDataForm.value.iconName,
    url: configDataForm.value.iconFullUrl,
  };
  // 背景图片
  configDataForm.value.backGroundImageObj = {
    name: configDataForm.value.backGroundImageName,
    url: configDataForm.value.backGroundImageFullUrl,
  };
}
// 表单规则
const rules = ref({
  iconNameObj: [{ required: true, message: '必填项', trigger: 'blur' }],
  textColor: [{ required: true, message: '必填项', trigger: 'blur' }],
  text: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 50, trigger: 'blur' },
  ],
  siteName: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 50, trigger: 'blur' },
  ],
  siteUrl: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 200, trigger: 'blur' },
  ],
});
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 处理输入框变化的事件
 *
 * @param inputKey 输入框的键名
 */
const handleInputChange = (inputKey) => {
  ruleFormRef.value.validateField(inputKey, (valid) => {});
};

/**
 * 处理取消
 */
const handleCancel = () => {
  emits('handle-show-edit-form', false);
};
/**
 * 处理保存
 */
const handleSave = (form) => {
  const formEl = ruleFormRef.value;

  formEl.validate((valid, fields) => {
    if (valid) {
      // 待数据更新完成后才执行
      nextTick(() => {
        emits('handle-edit-components-content', false);
        emits('update:modelValue', {
          backGroundImageObj: configDataForm.value.backGroundImageObj,
          backGroundImageName: configDataForm.value.backGroundImageName,
          backGroundImageFileKey:
            configDataForm.value.backGroundImageFileKey || 'backgroundImage',
          backGroundColor: configDataForm.value.backGroundColor,
          title: configDataForm.value.title,
          fontColor: configDataForm.value.fontColor,
          iconImageObj: configDataForm.value.iconImageObj,
          iconName: configDataForm.value.iconName,
          iconFileKey: configDataForm.value.iconFileKey,
          items: configDataForm.value.items,
        });
      });
      // TODO 待完成保存逻辑
    } else {
      console.log('error submit!', fields);
    }
  });
};

/**
 * 处理删除
 */
const handleDel = (scope) => {
  configDataForm.value.items.splice(scope.$index, 1);
};

/**
 * 处理添加一条离职规则
 */
const handleAdd = () => {
  // 获取当前最大排序号

  const sortNumArr = configDataForm.value.items.map((f) => {
    return f.sortNum;
  });

  let sortNum = Math.max(...sortNumArr);

  configDataForm.value.items.push({
    sortNum: (sortNum += 1),
    siteName: '',
    siteUrl: '',
  });
  configDataForm.value.items.push({
    sortNum: (sortNum += 1),
    siteName: '',
    siteUrl: '',
  });
  configDataForm.value.items.push({
    sortNum: (sortNum += 1),
    siteName: '',
    siteUrl: '',
  });
};

// #endregion
</script>

<style scoped lang="scss">
.friend-link-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  margin: auto;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.friend-link-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background: var(--el-color-white);
}

.friend-link-btn-container button {
  margin: 8px;
}

:deep(.el-alert .el-icon) {
  font-size: 22px;
}

:deep(.el-alert__description) {
  margin: 0;
}

:deep(.el-table .cell) {
  padding: 0 12px !important;
}

:deep(.cell) {
  /* line-height: 50px; */
  display: flex;
  align-items: center;
  height: 66px;
}

:deep(.el-table .el-form-item) {
  width: 100%;
}

.table-append {
  min-height: 40px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 35px;
  text-align: center;
  border-bottom: 1px solid var(--el-color-grey-light-2);
}

.table-append .el-link {
  font-size: 13px;
}

:deep(.el-table .el-form-item__content) {
  margin-left: unset !important;
}

/* stylelint-disable-next-line no-duplicate-selectors */
:deep(.el-table .el-form-item) {
  margin: unset !important;
}

/* stylelint-disable-next-line no-duplicate-selectors */
:deep(.el-table .el-form-item) {
  margin-top: 18px;
}

.form-item-label :deep(.el-form-item__label) {
  align-items: center;
}

:deep(.el-form) {
  width: 100%;
  padding: 20px;
}
</style>
